/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Selectors, ActionCreators } from 'store/ducks/watchTv/currentChannel';
import { ActionButton } from 'types/components/ActionButtonsGroup';
import translate from 'services/i18n/translate';
import { Hero } from 'ui/components';
import { AssetUtils, Ducks, EntryPoint, MenuUiArea } from '@wit/vtv-x-foundation-lib';
import WatchTvWrapper from 'ui/components/WatchTv/WatchTvWrapper';
import { StoreState } from 'store/store';
import useIsAdultContent from '../../../hooks/useIsAdultContent';
import useAssetTitle from '../../../hooks/useAssetTitle';
import { useRouter } from '../../../hooks/useRouter';

export default function MainPage(): JSX.Element {
  const router = useRouter();
  const dispatch = useDispatch();
  const buttonsRef = React.useRef<ActionButton[]>([]);

  const currentChannel = useSelector(Selectors.currentChannel);
  const currentProgram = useSelector((state: StoreState) => {
    if (currentChannel) {
      const current = Ducks.Epg.Live.Selectors.getLive(state, currentChannel.epgId);
      return current;
    }
    return undefined;
  });
  const menuItem = useSelector((store: StoreState) => Ducks.Menu.Selectors.getMainMenuItem(store, MenuUiArea.EPG));
  const isAdultContent = useIsAdultContent(currentProgram);
  const programTitle = useAssetTitle(currentProgram, false);

  const labelOnNow = currentChannel ? translate['watchtv.onNow'] : '';

  useEffect(() => {
    dispatch(ActionCreators.init());
  }, [dispatch]);

  useEffect(() => {
    if (currentChannel && currentProgram === undefined) {
      dispatch(Ducks.Epg.Live.Creators.requestLive(currentChannel.epgId));
    }

    if (currentChannel && currentProgram && AssetUtils.isPlayableChannel(currentChannel)) {
      const actionButton: ActionButton = {
        key: 'watchtvBtnNow',
        text: translate['watchtv.watchLive'],
        onClick: () => {
          router.push({ asset: currentChannel, entryPoint: EntryPoint.CLU, menuItemId: menuItem?.id });
        },
      };
      buttonsRef.current = [actionButton];
    }
  }, [dispatch, currentChannel, currentProgram, router, menuItem?.id]);

  return (
    <div className="watchtv" id="WatchTv">
      <Hero
        className="hero-container"
        title={programTitle}
        subtitle={isAdultContent !== undefined ? labelOnNow : undefined}
        backgroundImage={isAdultContent === false ? currentProgram?.images.background : undefined}
        actionButtons={isAdultContent === false ? buttonsRef.current : []}
      />
      <WatchTvWrapper />
    </div>
  );
}
